(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fx-top-categories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const boxes = document.querySelectorAll('.fx-topcat .fx-topcat__media[data-col-handle]');
  boxes.forEach(async (box) => {
    // Si une image a déjà été rendue par Liquid (from image_picker), on ne touche pas
    if (box.querySelector('img[data-liquid="1"]')) return;

    const handle   = box.dataset.colHandle;
    const title    = box.dataset.title || '';
    const fallback = box.dataset.fallback;

    // Sans handle, on injecte le fallback et on sort
    if (!handle) {
      const img = new Image();
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = title;
      img.src = fallback;
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'contain';
      box.innerHTML = '';
      box.appendChild(img);
      return;
    }

    let src = null;

    // 1) Image de collection
    try {
      const colRes = await fetch(`/collections/${handle}.json`, { credentials: 'same-origin' });
      if (colRes.ok) {
        const colJson = await colRes.json();
        if (colJson && colJson.collection && colJson.collection.image && colJson.collection.image.src) {
          src = colJson.collection.image.src;
        }
      }
    } catch(e) { /* no-op */ }

    // 2) 1re image produit si pas d'image de collection
    try {
      if (!src) {
        const prodRes = await fetch(`/collections/${handle}/products.json?limit=1`, { credentials: 'same-origin' });
        if (prodRes.ok) {
          const prodJson = await prodRes.json();
          const p0 = prodJson && prodJson.products && prodJson.products[0];
          if (p0 && p0.images && p0.images[0] && p0.images[0].src) {
            src = p0.images[0].src;
          }
        }
      }
    } catch(e) { /* no-op */ }

    // 3) Fallback
    if (!src) src = fallback;

    // Injection <img>
    const img = new Image();
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = title;
    img.src = src;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'contain';

    box.innerHTML = '';
    box.appendChild(img);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}
customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
